import type { MensagemAgendada, MensagemEnviada } from "../../../services/enviosIzza"

export type VerEnviosIzzaModel = {
    enviadas: MensagemEnviada[]
    agendadas: MensagemAgendada[]
}

export const VerEnviosIzzaInicial: VerEnviosIzzaModel = {
    enviadas: [],
    agendadas: [],
}
